import { Grid, CircularProgress } from "@mui/material";

function CircularLoading() {
  return (
    <Grid container textAlign={"center"} py={6}>
      <Grid item xs={12}>
        <CircularProgress  color="primary" />
      </Grid>
    </Grid>
  );
}
export default CircularLoading;
